import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Order, OrderSearchingCriteria } from '@app/models/order';


@Injectable()
export class OrderService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: OrderSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Order>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new OrderSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/order`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <Order[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    } 

    get(id: string): Observable<Order> {
        return this.httpClient.get(`${environment.API_END_POINT}/order/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Order>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }




}